export const SLIDER_WIDTH = Math.min(336, document.body.clientWidth - 39);
